@if (useImage) {
  <div class="arbetsorder-info-icon ao-icon">
    <img [src]="imgSrc | aoIconUrl"/>
  </div>
}
@if (!useImage) {
  <div class="arbetsorder-info-icon">
    <div class="arbetsorder-info-icon-text icon-style-{{svgShape}}">{{iconText}}</div>
    <svg viewBox="0 -1 32 32" x="0" y="0" width="32" height="32" xmlns="http://www.w3.org/2000/svg">
      <svg [attr.x]="svgXPos" y="0" viewBox="-0.5 -0.5 32 32" [attr.style]="svgStyle" width="32" height="32">
        @if (svgShape === 'PATH') {
          <path [attr.d]="svgPath"></path>
        }
        @if (svgShape === 'CIRCLE') {
          <circle [attr.r]="circleRadius" [attr.cx]="circleRadius" [attr.cy]="circleRadius"></circle>
        }
        @if (svgShape === 'RECT') {
          <rect [attr.width]="squareSize" [attr.height]="squareSize" [attr.rx]="squareRoundness"></rect>
        }
      </svg>
    </svg>
  </div>
}
